import split from "webutils/datum-split.htm";
import stacked from "webutils/datum-stacked.htm";
import inline from "webutils/datum-inline.htm";
import compact from "webutils/datum-compact.htm";
import stacked_inverse from "webutils/datum-stacked-inverse.htm";

export default {
  bindings: {
    label: "@",
    labelColor: "@",
    labelSize: "@",
    value: "@",
    valueColor: "@",
    valueSize: "@"
  },
  transclude: {
    label: "?label",
    value: "?value"
  },
  templateUrl($attrs) {
    const layout = $attrs.type || $attrs.layout;
    return $attrs.templateUrl
      ? $attrs.templateUrl
      : layout
        ? `datum-${layout}.htm`
        : stacked;
  }
};
